"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_query_1 = require("@tanstack/react-query");
const prefetcher_1 = require("./prefetcher");
const gatsby_query_store_1 = require("../../layouts/gatsby-query-store");
const fetchData = async (props) => {
    try {
        let queryUrl = '';
        queryUrl = `/api/gatsby-plugin-atollon/filter`;
        if (queryUrl) {
            return fetch(queryUrl, {
                method: "POST",
                body: JSON.stringify(props)
            })
                .then(res => res.json());
        }
    }
    catch (e) {
        return null;
    }
    return null;
};
const useFilters = (props) => {
    const globalData = (0, gatsby_query_store_1.useGatsbyQueryStore)();
    const modelTrack = globalData.data.datoCmsModelTrack.modelTrack;
    const prefetchedData = (0, prefetcher_1.usePrefetch)(props, modelTrack);
    const prefetchAttachedIds = (0, prefetcher_1.usePrefetchAttachedIds)(props, modelTrack);
    const queryClient = (0, prefetcher_1.useQueryClient)();
    const [propsState, setPropsState] = react_1.default.useState(props);
    react_1.default.useEffect(() => {
        setPropsState(props);
    }, [JSON.stringify(props)]);
    const setAll = (filters) => {
        setPropsState(filters);
    };
    const setSort = (sort) => {
        setPropsState((e) => ({
            ...e,
            sort: sort
        }));
    };
    const setType = (type) => {
        setPropsState((e) => ({
            ...e,
            type: type
        }));
    };
    const setFieldFilter = (fields) => {
        setPropsState((e) => ({
            ...e,
            fields: {
                ...e.fields,
                ...Object.entries(fields).reduce((acc, [k, v]) => {
                    if (v === null || v === undefined || v === "" || ("matches" in v && v.matches === "")) {
                        return acc;
                    }
                    return {
                        ...acc,
                        [k]: v
                    };
                }, {}),
            }
        }));
    };
    const combineFieldFilter = (fields) => {
        setPropsState((e) => ({
            ...e,
            fields: {
                ...e.fields,
                ...Object.entries(fields).reduce((acc, [k, v]) => {
                    if (v === null || v === undefined || v === "" || ("matches" in v && v.matches === "")) {
                        if (e.fields[k]) {
                            return e.fields[k];
                        }
                        return acc;
                    }
                    let n = v;
                    if (e.fields[k]) {
                        n = {
                            ...e.fields[k],
                            ...v,
                        };
                    }
                    return {
                        ...acc,
                        [k]: n
                    };
                }, {}),
            }
        }));
    };
    const removeFieldFilter = (fieldName) => {
        setPropsState((e) => ({
            ...e,
            fields: Object.entries(e.fields).reduce((acc, [k, v]) => {
                if (k === fieldName) {
                    return acc;
                }
                return {
                    ...acc,
                    [k]: v
                };
            }, {})
        }));
    };
    if (process.env.NODE_ENV === 'development') {
        /*if (invariant1 || invariant2 || invariant3) {
            console.log('Invariant Error', props, invariant1, invariant2, invariant3);
            throw new Error('Invariant Error: Incorrect Format for useFilters');
        }*/
    }
    const { isLoading, error, data: foundData, fetchNextPage, hasNextPage } = (0, react_query_1.useInfiniteQuery)({
        queryKey: propsState ? [JSON.stringify(propsState)] : ['default'],
        /*initialData: prefetchedData ? {
            pageParams: [1],
            pages: [prefetchedData]
        } : undefined,*/
        queryFn: async ({ pageParam = 1, }) => {
            const endpointData = await fetchData({
                ...propsState,
                modelTrack,
                page: pageParam.page,
                referenceSkip: pageParam.referenceSkip,
                previousIds: pageParam.previousIds,
            });
            if (endpointData.message) {
                throw new Error(`${endpointData.message} - ${endpointData.reason}`);
            }
            if (endpointData) {
                return endpointData;
            }
            return {
                ids: [],
                currentPage: null,
                totalPages: null,
            };
        },
        initialPageParam: { page: 1, referenceSkip: 0, previousIds: [] },
        getNextPageParam: (lastPage, allPages) => {
            if (lastPage?.currentPage === "*") {
                if (lastPage.hasMore) {
                    return { referenceSkip: lastPage.referenceSkip, previousIds: allPages.flatMap(x => x.ids), };
                }
            }
            else if (lastPage?.currentPage !== lastPage?.totalPages) {
                return { page: lastPage.currentPage + 1, };
            }
        },
    }, queryClient);
    const results = (0, react_query_1.useQueries)({
        queries: (foundData?.pages?.flatMap(x => x.ids) || []).map(searchItemId => ({
            queryKey: ['scoped-id', searchItemId],
            queryFn: () => fetch(`/__search/${searchItemId}.json`)
                .then(res => res.json()),
            /*initialData: prefetchAttachedIds[searchItemId],*/
        })),
    }, queryClient);
    const totalPages = foundData?.pages?.[0]?.totalPages || null;
    const currentPage = (() => {
        if (foundData?.pages?.[0]?.currentPage) {
            return foundData.pages[foundData.pages.length - 1].currentPage;
        }
        return null;
    })();
    const hasMore = (() => {
        if (foundData?.pages?.[0]?.hasMore) {
            return foundData.pages[foundData.pages.length - 1].hasMore;
        }
        return null;
    })();
    const totalCount = foundData?.pages?.[0]?.totalCount || null;
    const currentCount = (() => {
        if (foundData?.pages?.[0]?.currentCount) {
            return foundData.pages[foundData.pages.length - 1].currentCount;
        }
        return null;
    })();
    const pageNext = react_1.default.useCallback(() => {
        if (foundData && totalPages && currentPage) {
            if (currentPage === "*" && hasMore) {
                fetchNextPage();
            }
            else if (currentPage + 1 <= totalPages) {
                fetchNextPage();
            }
        }
    }, [totalPages, currentPage]);
    return {
        error: error?.message || null,
        totalPages,
        currentPage,
        hasMore: currentPage === "*" ? hasMore : currentCount < totalCount,
        pageNext,
        removeFieldFilter,
        setAll,
        setFieldFilter,
        combineFieldFilter,
        loading: Boolean(isLoading),
        results: results,
        sort: propsState?.sort || { type: 'scalar', fieldName: '_updatedAt', direction: 'desc' },
        fields: propsState?.fields || {},
        setSort,
        totalCount,
        currentCount,
        setType,
    };
    /**/
};
exports.default = useFilters;
//# sourceMappingURL=index.js.map